import { Toggle, type ToggleEntry } from '@warp-ds/react/components/toggle';
import type { FilterProps } from '@/scenes/resultPage/components/filters/types';

export const BrokerFilter = ({ filters: { is_private: isPrivateFromParam }, onFilterChanged }: FilterProps) => {
    // isPrivateParam == undefined is a valid case (Vis alle), so these checks need to be this specific
    const isPrivate = isPrivateFromParam === 'true';
    const isBusiness = isPrivateFromParam === 'false';

    const options: ToggleEntry[] = [
        { label: 'Vis alle', value: 'all' },
        { label: 'Kun privat', value: 'true' },
        { label: 'Kun bedrift', value: 'false' },
    ];

    const selectedFromParam = [isPrivate ? options[1] : isBusiness ? options[2] : options[0]];

    const onChange = (selectedEntry: ToggleEntry) => {
        const isPrivate = selectedEntry?.value === 'all' ? undefined : selectedEntry?.value === 'true';
        onFilterChanged({ is_private: isPrivate });
    };

    return (
        <fieldset data-testid="brokerFilter">
            <legend className="sr-only">Utleier</legend>
            <Toggle type="radio" options={options} defaultSelected={selectedFromParam} onChange={onChange} />
        </fieldset>
    );
};
